import * as Actions from "pages/Folders/store/folderActions";
import storage from "@storage";

const folderPersist = store => next => action => {
  let result = next(action);

  if (action.type === Actions.UPDATE_STATUS) {
    const state = store.getState();
    const status = state.entities.folders.status;
    storage.set("folderStatus", status);
  }

  return result;
};

export default folderPersist;
